export default class Appearance  {
    constructor() {
        this.navAppearance = document.querySelector('.nav-appearance');

        if (this.navAppearance) {
            this.initNavAppearance();
        }
    }

    initNavAppearance() {
        const button = this.navAppearance.querySelector('button');
        const textLight = this.navAppearance.dataset.textLightMode;
        const textDark = this.navAppearance.dataset.textDarkMode;

        const updateAriaLabel = () => {
            button.setAttribute('aria-label', document.documentElement.classList.contains('dark-mode') ? textDark : textLight);
        };

        updateAriaLabel();

        button.addEventListener('click', () => {
           if (document.documentElement.classList.contains('dark-mode')) {
               document.documentElement.classList.remove('dark-mode');
               localStorage.setItem('appearance', 'light');
           } else {
               document.documentElement.classList.add('dark-mode');
               localStorage.setItem('appearance', 'dark');
           }
           updateAriaLabel();
        });
    }
}